import React, { useCallback } from 'react'

import TextButton from 'components/Luxkit/Button/TextButton'
import { useAppSelector } from 'hooks/reduxHooks'
import { appViewMessageHandler } from 'lib/window/webViewUtils'
import { isHeadlessModeSel } from 'selectors/configSelectors'
import FooterWithCreateUpdateInfo from 'tripPlanner/components/TripModal/Common/FooterWithCreateUpdateInfo'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import { CLOSE_MODAL } from 'tripPlanner/types/common'
import { TripItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: TripItem
}

export default function ReadOnlyItemFooter({ item }: Props) {
  const isHeadless = useAppSelector(isHeadlessModeSel)
  const { closeModal } = useModalCallbacks()

  const onClose = useCallback(() => {
    if (isHeadless) {
      appViewMessageHandler('nativeNavigation', CLOSE_MODAL)
    }
    closeModal()
  }, [closeModal, isHeadless])

  return (
    <FooterWithCreateUpdateInfo item={item}>
      <TextButton size="large" kind="primary" onClick={onClose}>
        Done
      </TextButton>
    </FooterWithCreateUpdateInfo>
  )
}
